import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Eye, EyeOff, LogIn } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const LoginPage = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const { authService } = await import('../services/authService');
      await authService.login(formData.email, formData.password);
      
      toast({
        title: 'Login realizado com sucesso!',
        description: 'Redirecionando para o portal...',
      });
      
      setTimeout(() => {
        navigate('/portal/dashboard');
      }, 1000);
    } catch (error) {
      toast({
        title: 'Erro ao fazer login',
        description: error.response?.data?.detail || 'Verifique suas credenciais e tente novamente.',
        variant: 'destructive',
      });
    }
  };

  return (
    <div className="min-h-screen nexti-gradient flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-center space-y-2">
          <div className="flex justify-center mb-4">
            <img 
              src="/nexti-logo.png" 
              alt="NexTI" 
              className="h-16 w-auto"
              style={{ filter: 'drop-shadow(0 3px 8px rgba(0, 0, 0, 0.9)) drop-shadow(0 1px 3px rgba(0, 0, 0, 0.7))' }}
            />
          </div>
          <CardTitle className="text-2xl font-bold">Portal</CardTitle>
          <CardDescription>Acesse o sistema interno da NexTI</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="seu.email@nexti.com.vc"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <div className="relative">
                <Input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Digite sua senha"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              className="w-full bg-[#4A2B7F] hover:bg-[#6B46C1] text-white py-6 text-base font-semibold"
            >
              <LogIn className="w-5 h-5 mr-2" />
              Entrar
            </Button>

            <div className="text-center mt-4">
              <button
                type="button"
                className="text-sm text-[#4A2B7F] hover:underline"
              >
                Esqueceu sua senha?
              </button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;